import { useLocation } from 'react-router-dom'

export default () => {
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  return params.get('show-basline-settings') === 'true'
}
